/**
 * Gazeparts contact popup — open/close behavior for the site-wide floating
 * "Contact us" button. The form itself (validation, submit, honeypot/
 * rate-limit spam protection, photos) is entirely handled by the
 * <gp-contact-form> element defined in gp-contact-form.js; this file only
 * wires the trigger/overlay/close chrome around it, same pattern as any
 * simple disclosure widget.
 */
(function () {
  'use strict';

  function initPopup(root) {
    var trigger = root.querySelector('[data-gp-popup-open]');
    var overlay = root.querySelector('[data-gp-popup-overlay]');
    var closeBtn = root.querySelector('[data-gp-popup-close]');
    var dialog = root.querySelector('[data-gp-popup-dialog]');
    if (!trigger || !overlay) return;

    var lastFocused = null;

    function onKeydown(event) {
      if (event.key === 'Escape') close();
    }

    function open() {
      lastFocused = document.activeElement;
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
      var firstField = dialog && dialog.querySelector('input, textarea');
      if (firstField) firstField.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    trigger.addEventListener('click', function () {
      if (overlay.hidden) {
        open();
      } else {
        close();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) close();
    });
  }

  var roots = document.querySelectorAll('[data-gp-contact-popup]');
  for (var i = 0; i < roots.length; i++) {
    initPopup(roots[i]);
  }
})();